import React, { useState } from "react";

import "./projects-component-styles.scss";

import projectDetails from "./projects-data";

// importing components
import ProjectCardComponent from "../../components/project-card-component/project-card-component";
import FilterCategComponent from "../../components/filter-categ-component/filter-categ-component";

const ProjectsComponent = () => {
	const filterCategs = [
		"All",
		"Web Development",
		"Web Applications",
		"UI/UX Design",
	];
	const [activeFilter, setActiveFilter] = useState("All");

	const filteredProjects = projectDetails.filter((project) => {
		if (activeFilter === "All") {
			return true;
		}
		return project.type === activeFilter;
	});

	return (
		<div className="projects-section">
			{/* Filter Categories */}
			<FilterCategComponent
				filterCategs={filterCategs}
				activeFilter={activeFilter}
				setActiveFilter={setActiveFilter}
			/>

			{/* Projects */}
			{filteredProjects
				.map((project, index) => (
					<ProjectCardComponent
						key={project.title}
						title={project.title}
						type={project.type}
						description={project.description}
						imgSrc={project.imgSrc}
						projectNo={`0${index + 1}.`}
						btnLink={project.btnLink}
						brightColor={project.brightColor}
						mediumColor={project.mediumColor}
						lightColor={project.lightColor}
					/>
				))
				.filter((_, index) => index < 3)}
		</div>
	);
};

export default ProjectsComponent;
